var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 778.1 646.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b53cac0e-e40a-4593-b631-dfb9c94cebff",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bc949c4a-47df-41a2-a1a6-c4cad09b203a",
    "data-name": "a928d488-6e6c-46d7-ac2c-f12f8bd647b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M741.44,84.36a50.3,50.3,0,0,1,35.06,61h0l-.27,1L645.68,611.87c-6,21.59-25.95,34.67-48.38,34.67a49.94,49.94,0,0,1-13.54-1.87l-183-49,.54-1.93,183,49a48.11,48.11,0,0,0,13,1.8c21.54,0,40.64-12.48,46.46-33.21L774,146.71l.29-1A48.31,48.31,0,0,0,740.9,86.28L446.7,3.79A48.29,48.29,0,0,0,387.24,37.2L377,73.66l-1.92-.54,10.22-36.46a50.3,50.3,0,0,1,61.92-34.8Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.9,86.28a48.31,48.31,0,0,1,33.43,59.42l-.29,1L643.76,611.33c-5.82,20.73-24.92,33.21-46.46,33.21a48.11,48.11,0,0,1-13-1.8l-183-49-3.34-71.63,2.38-.11,188.5,52.86,1,.27L709.11,149.55l.27-1L442.19,73.66l-1-.27L400.37,219.08l-14.18,51.16L377,73.66,387.24,37.2A48.29,48.29,0,0,1,446.7,3.79Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "709.38 148.59 709.11 149.55 589.77 575.14 588.81 574.87 400.31 522.01 400.85 520.08 588.39 572.67 706.92 149.97 442.61 75.86 402.3 219.63 400.37 219.08 441.23 73.39 442.19 73.66 709.38 148.59",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.3 219.63 386.4 274.76 386.19 270.24 400.37 219.08 402.3 219.63",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.93 522.12 401.27 593.75 400.73 595.68 375.1 73.12 377.02 73.66 386.19 270.24 385.95 271.09 386.32 275.03 386.4 274.76 397.93 522.12",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.19 270.24 386.4 274.76 386.32 275.03 385.95 271.09 386.19 270.24",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.23,67.72H352.77A47.06,47.06,0,0,1,387,82.46q.74.78,1.44,1.59A47.13,47.13,0,0,1,400,115V598.49a47.29,47.29,0,0,1-47.23,47.23H47.23A47.29,47.29,0,0,1,0,598.49V115A47.28,47.28,0,0,1,47.23,67.72Zm290.52,509v-441H61.25v441Z",
    style: {
      fill: "#ffc539"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.25,135.76h276.5v441H61.25Zm2,439h272.5v-437H63.25Z",
    style: {
      fill: "#ffc539"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.25,317.61s4.22,41.45,2.92,43.93,25.45,45.62,25.45,45.62l39.62-39.36s-4-52.73-1.45-55.19S153.25,317.61,153.25,317.61Z",
    style: {
      fill: "#ffb8b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.25,317.61s4.22,41.45,2.92,43.93,25.45,45.62,25.45,45.62l39.62-39.36s-4-52.73-1.45-55.19S153.25,317.61,153.25,317.61Z",
    style: {
      isolation: "isolate",
      opacity: 0.10000000149011612
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.42,
    cy: 300.71,
    r: 47.63,
    style: {
      fill: "#ffb8b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,377.15l-5-2.6-24.74-21s-2.42-.82-2.57,6.7l-.14,7.52-15.26,11,4.25,170.58,107.78,2.06-.47-171.76L225,364.13l-4.73-9.36-26.82,20Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.72,573.87l2.6,0,167.85,3.21,7.34-186.64s-14.91-6.57-25-5.51c0,0-21-14.19-28.55-14.34s-19.77-15.41-19.77-15.41-.6,31.33-9.81,53.71-16.83,93.71-16.83,93.71l-37.84-117.3v-32a57.66,57.66,0,0,0-9.66,13c-3.91,7.44-16.6,16-16.6,16s-34.22,19.41-40.54,21.8S80,409,80,409l3.38,30.58,1.93,17.31Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.64,501.25c1.06,10.05-3.55,53.84-3.55,53.84l-1.84,3.16-1.79,3.07L74.06,413.55a7,7,0,0,1,2-2.32,17.28,17.28,0,0,1,4-2.25l5,.09S118.58,491.19,119.64,501.25Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.54,524.87s12.19-47.4,32.14-42-.77,40.1-.77,40.1Z",
    style: {
      fill: "#ffb8b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.27,527.18s-47.6-2.17-47.67,1.59-6.79,27.45-3,27.52,32.6-.63,32.58.63,15,4.05,15,4.05Z",
    style: {
      fill: "#ffb8b8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.06 567.72 184.13 578.01 117.85 577.1 115.72 573.89 110.67 554.44 113.34 554.75 116.09 555.09 186.06 567.72",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.06,527.44s-16.25-2.82-16.27-1.56-10.78,39.91-5.78,40,23.74,4.22,23.74,4.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.74,390.33l8.77.17s5,.1,7.38,7.66,18,41.72,15.45,44.18-3.79,1.18-1.33,3.73,3.74,1.33,2.44,3.81,11.23,67.91,3.23,92.83-9.47,36.16-14.48,36.08L176.27,576.3s-7-49-2-50.18,91.6-4.51,91.6-4.51S265.92,391.23,284.74,390.33Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.13,257.24l-9-3.46s19.25-18.53,45.51-16.38l-7.22-7.53s18.19-6.22,34.29,11.34c8.46,9.24,18.25,20.09,24.25,32.21l9.68.19-4.2,8,14,8.35L240,288.23a40.79,40.79,0,0,1-1.77,20.89l-3.46,9s-12.64-26.54-12.58-29.83l-.15,8.22s-8.9-7.57-8.8-12.5l-5,5.66-2.29-9.09L175.34,289l5.07-7.3-18.94,2.1L169,275s-21.56,10.27-22.56,19.29-11.89,20.31-11.89,20.31l-4.77-8.31S123.07,269.11,147.13,257.24Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.96, 0.27, -0.27, 0.96, 421.84, 316.51)",
    style: {
      isolation: "isolate",
      fontSize: 70,
      fill: "#ffc539",
      fontFamily: "Chalkduster",
      letterSpacing: "-0.06600167410714286em"
    }
  }, "P"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.96, 0.27, -0.27, 0.96, 465.23, 328.77)",
    style: {
      isolation: "isolate",
      fontSize: 70,
      fill: "#2d4059",
      fontFamily: "Chalkduster",
      letterSpacing: "-0.051004464285714285em"
    }
  }, "a"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.96, 0.27, -0.27, 0.96, 508.18, 340.9)",
    style: {
      isolation: "isolate",
      fontSize: 70,
      fill: "#2d4059",
      fontFamily: "Chalkduster",
      letterSpacing: "0.0009974888392857142em"
    }
  }, "r"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.96, 0.27, -0.27, 0.96, 543.77, 350.95)",
    style: {
      isolation: "isolate",
      fontSize: 70,
      fill: "#2d4059",
      fontFamily: "Chalkduster",
      letterSpacing: "0.0049944196428571425em"
    }
  }, "t"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.96, 0.27, -0.27, 0.96, 574.88, 359.73)",
    style: {
      isolation: "isolate",
      fontSize: 70,
      fill: "#2d4059",
      fontFamily: "Chalkduster"
    }
  }, "i")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKort);
export default __webpack_public_path__ + "static/media/kort.331bd38e.svg";
export { ForwardRef as ReactComponent };